import { render, staticRenderFns } from "./mo-autocomplete-wrapper.html?vue&type=template&id=577f01c9&external"
import script from "./mo-autocomplete-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-autocomplete-wrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/5/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577f01c9')) {
      api.createRecord('577f01c9', component.options)
    } else {
      api.reload('577f01c9', component.options)
    }
    module.hot.accept("./mo-autocomplete-wrapper.html?vue&type=template&id=577f01c9&external", function () {
      api.rerender('577f01c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-autocomplete-wrapper/mo-autocomplete-wrapper.vue"
export default component.exports